<template>
  <oms-filter-dropdown :title='title' :icon='icon' :is-filtering='isFiltering'>
    <h6>{{ t('features.vue.shared.filters.include') }}</h6>
    <textarea class='form-control mb-4' v-model='includedIds' type='text' rows='10' cols='150'
      :placeholder="t('features.vue.shared.filters.paste_placeholder', { placeholder: resolvedPlaceholder })" />

    <h6>{{ t('features.vue.shared.filters.exclude') }}</h6>
    <textarea class='form-control' v-model='excludedIds' type='text' rows='10' cols='150'
      :placeholder="t('features.vue.shared.filters.paste_placeholder', { placeholder: resolvedPlaceholder })" />
  </oms-filter-dropdown>
</template>

<script>
import Multiselect from 'vue-multiselect'
import OmsFilterDropdown from '../filter-dropdown.vue'

export default {
  inject: ['i18n'],

  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'ri-focus-line'
    },
    placeholder: {
      type: String,
      default: ''
    },
    modelValue: Object
  },

  components: { Multiselect, OmsFilterDropdown },

  computed: {
    resolvedPlaceholder() {
      return this.placeholder || this.t('features.vue.shared.filters.ids')
    },

    isFiltering() {
      return this.modelValue?.include?.filter(Boolean)?.length > 0 || this.modelValue?.exclude?.filter(Boolean)?.length > 0
    },

    includedIds: {
      get() {
        const ids = this.modelValue?.include || []
        return ids.join(',')
      },

      set(content) {
        this.$emit('update:modelValue', { ...(this.modelValue || {}), include: content.split(/[,\n]/).map(id => id.trim()) })
      }
    },

    excludedIds: {
      get() {
        const ids = this.modelValue?.exclude || []
        return ids.join(',')
      },

      set(content) {
        this.$emit('update:modelValue', { ...(this.modelValue || {}), exclude: content.split(/[,\n]/).map(id => id.trim()) })
      }
    }
  },

  methods: {
    t(key, options) {
      return this.i18n ? this.i18n.t(key, options) : key
    }
  }
}
</script>
